import type { FC } from 'react'

import { useRundown } from '@/features/rundown/rundown.derived'

import { useGroupTiming, useGroupTimestamps } from './group.hooks'
import type { GroupChildren } from './group.types'
import { GroupPlannedDuration } from './GroupPlannedDuration'
import { GroupPlannedTimeRange } from './GroupPlannedTimeRange'
import { GroupTimingsRow } from './GroupTimingsRow'

type GroupPlannedTimingsProps = {
  childrenCues: GroupChildren
}

export const GroupPlannedTimings: FC<GroupPlannedTimingsProps> = ({
  childrenCues,
}) => {
  const rundown = useRundown()
  const groupTimestamps = useGroupTimestamps(childrenCues)
  const groupTiming = useGroupTiming(groupTimestamps)
  if (!groupTiming) return null

  return (
    <GroupTimingsRow
      Duration={<GroupPlannedDuration groupTiming={groupTiming} />}
      Range={
        <GroupPlannedTimeRange
          groupTiming={groupTiming}
          timezone={rundown.timezone}
          todDisplayFormat={rundown.settings.todDisplayFormat}
        />
      }
    />
  )
}
